import React, { useState } from 'react';
import '../../component-styles/ManualCreditModal.css';
import API_BASE from '../../utils/api';

export default function NewCreditModal({ projectId, onClose, onCreated }) {
  const [form, setForm] = useState({
    date: new Date().toISOString().slice(0, 10),
    description: '',
    amount: '',
  });

  const update = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const save = async () => {
    const body = {
      projectId,
      date: form.date,
      description: form.description,
      total: Number(form.amount),
      availableBalance: Number(form.amount),
      type: 'manual',
    };

    const res = await fetch(`${API_BASE}/api/credits/manual`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        userid: localStorage.getItem('userId'),
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    onCreated(data);
    onClose();
  };

  return (
    <div className="manualcredit-overlay">
      <div className="manualcredit-card">
        <div className="manualcredit-head">
          <h3>New Credit</h3>
          <button className="manualcredit-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="manualcredit-body">
          <label className="manualcredit-label">Date</label>
          <input
            type="date"
            name="date"
            className="manualcredit-input"
            value={form.date}
            onChange={update}
          />

          <label className="manualcredit-label">Description</label>
          <input
            type="text"
            name="description"
            className="manualcredit-input"
            placeholder="Returned item, adjustment, etc."
            value={form.description}
            onChange={update}
          />

          <label className="manualcredit-label">Amount</label>
          <input
            type="number"
            name="amount"
            className="manualcredit-input"
            placeholder="0.00"
            value={form.amount}
            onChange={update}
          />
        </div>

        <div className="manualcredit-footer">
          <button className="manualcredit-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="manualcredit-btn-primary" onClick={save}>
            Save Credit
          </button>
        </div>
      </div>
    </div>
  );
}
